import $ from 'jquery';
import 'semantic-ui-css/components/popup';
import scrollIntoView from 'scrollIntoView';

import 'sylius/admin/app';

import './code';
import './import_collection_widget';
import './jquery.multiselect';
import './multiselect';
import './popups';
import './shipping-sizes';
import './sylius-product-images-preview';
import './ChannelPayment/stripe';
import './ContentEmail/reset-email-content';
import './Report/Chart/bar';
import './StockVariant/radio';
import './code-fields-hide';
import './code-grid-hide';
import './options-code';
import './taxon-code';

(function($) {
    'use strict';

    jQuery(function($) {
        $(document).ready(function () {
            $(document).previewUploadedImage('#sylius_product_images');
            $(document).previewUploadedImage('#sylius_taxon_images');
            $(document).previewUploadedImage('#sylius_channel_images');

            scrollIntoView($('form[name="sylius_taxon"]').get(0), {align: {left: 1}});

            $('.collapsible-category-list .segment > .list > .item > .item').click(function(e) {
                e.preventDefault();

                $(this).siblings('.folder, .content').toggleClass('category-visible');
            });
        });
    });
})(jQuery);
